import React, { FC, ReactElement, useEffect, useRef, useState } from 'react';

import './Richtext.scss';
import styled from 'styled-components';

import { Froala } from './froalaTextEditor/Froala';
import { animateRkpi, getRkpiDurationFromSpeed } from './froalaTextEditor/utils/rkpi';
import { getRkpiDataFromAttrs } from './froalaTextEditor/utils/rkpi';

export type RichTextProps = {
  defaultContent: string | null;
  content: string;
  editorPlugins: any | null;
  path: {
    slideIndex: number;
    comboIndex: number;
    setIndex: number;
    groupIndex: number;
    elementIndex: number | null;
  } | null;
  placeholder: string | null;
  isButton: boolean | null;
  isSettingsTool: boolean | null;
  width: number;
  horizontalAlignment: string | undefined;
};

interface richTextElementProps {
  width: number;
}

const RichTextElement = styled.div<richTextElementProps>`
  &.content {
    text-align: inherit;
    width: ${(props) => props.width || 100}%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`;

const RichText: FC<RichTextProps> = ({ ...props }): ReactElement => {
  let content = props.content;
  const uuid = props.editorPlugins?.uuid;
  const [froalaId] = useState(uuid ? uuid() : Math.round(new Date().getTime()));

  const finalContent = content || '';
  const isEditor = !!props.editorPlugins?.froalaEditor;

  if (isEditor) {
    return <Froala {...props} id={froalaId} path={props.path} />;
  } else {
    return (
      <StyledWrapper horizontalAlignment={props.horizontalAlignment}>
        <RichTextElement
          id={`rich-text-${froalaId}`}
          className="content"
          width={props.width}
          dangerouslySetInnerHTML={{ __html: finalContent }}
        />
      </StyledWrapper>
    );
  }
};

const StyledWrapper = styled.div<{ horizontalAlignment: string | undefined }>`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: ${({ horizontalAlignment }) => horizontalAlignment || 'inherit'};
`;

const settings = [
  [
    {
      settingName: 'FroalaEditor',
    },
  ],
];

export default {
  RichText,
  settings,
  label: 'Text',
};
